import { useRequest } from '@features/request/useRequest';

import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import type { TTypeItemEditVariables } from '../../TypeItem/TypeItem';
import { createCatalogLimitedCostTypeGql, updateCatalogLimitedCostTypeGql } from '../CatalogLimitedTypeQueries';

type TProps = {
    onSuccess: () => void;
};

export const useCreateOrUpdateLimitedCostType = ({ onSuccess }: TProps) => {
    const dispatch = useDispatch();

    const [, , , createRequest] = useRequest({
        requestId: 'createLimitedCostType',
        query: createCatalogLimitedCostTypeGql,
        withEffect: false,
        dependenciesUpdater: onSuccess,
    });

    const [, , , updateRequest] = useRequest({
        requestId: 'updateLimitedCostType',
        query: updateCatalogLimitedCostTypeGql,
        withEffect: false,
        dependenciesUpdater: onSuccess,
    });

    return useCallback(
        ({ id, ...input }: TTypeItemEditVariables) =>
            dispatch(id ? updateRequest({ id, input }) : createRequest({ input })),
        [dispatch, updateRequest, createRequest],
    );
};
